import NotInformation from './../../../../../components/NotInformation';
import DividerWithText from './../../../../../components/DividerWithText';
import { useTranslation } from 'react-i18next';
import RowResumeText from '../../../../../components/RowResumeText';
import PhotoPickerSummary from '../../../../../components/PhotoPicker/PhotoPickerSummary';
import { Diets } from '../../../../../enums/FoodieIcons';
import { EMPTY_VALUES } from '../../../../../Apis/functions';
/**
 * @Author: Susana Garcia Rodriguez
 * @JobTitle : Frontend
 * @Email : sgarcia@ibl.mx
 *
 */

const DishSummary = ({ item, selectedAllergens, selectedImage, selectedIngredients, dishData, selectedDietTypes }) => {
    const { t } = useTranslation();

    return (
        <>
            <div className='row mb-5'>
                <DividerWithText title={t('photography')} />
                <PhotoPickerSummary photoPicker={selectedImage} classWith={'w-400px'} />
                <DividerWithText title={t('details')} />
                <div className='d-flex justify-content-center'>
                    <div className={'summary-container input-padding-top'}>
                        <div className='d-flex flex-column align-items-start justify-content-center width-600px'>
                            <div className='row w-100'>
                                <div className='col-sm-12 col-md-6 col-lg-6 col-xl-6 p-0'>
                                    <RowResumeText title={t('name')} value={item.name} />
                                </div>
                               <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6 p-0 mt-3 mt-md-0">
                                    <div className={'same-width'}>
                                        <RowResumeText title={t('item_code')} value={item.code} />
                                    </div>
                                </div>
                            </div>
                            <div className='mt-3'>
                                <RowResumeText
                                    title={t('ingredients')}
                                    value={
                                        Array.isArray(selectedIngredients)
                                            ? selectedIngredients.map(
                                                  (i) => `${t(i.label)} ${t(i.unit)} ${t('of')} ${t(i.subtitle)}`,
                                              )
                                            : []
                                    }
                                />
                            </div>
                            <div className='row w-100 mt-3'>
                                <div className='col-sm-12 col-md-6 col-lg-6 col-xl-6 p-0'>
                                    <RowResumeText
                                        title={t('food_present_diet_type')}
                                        value={
                                            Array.isArray(selectedDietTypes) && selectedDietTypes.length > 0
                                                ? selectedDietTypes.map((diet) =>
                                                      Diets[diet.id] ? t(Diets[diet.id].name) : t('unknown_diet'),
                                                  )
                                                : EMPTY_VALUES.DEFAULT
                                        }
                                    />
                                </div>
                                <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6 p-0 mt-3 mt-md-0">
                                    <div className={'same-width'}>
                                        <RowResumeText
                                            title={t('allergens')}
                                            value={
                                                Array.isArray(selectedAllergens)
                                                    ? selectedAllergens.map((i) => `${t(i.label)}`)
                                                    : []
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className='mt-3'>
                                <RowResumeText title={t('description')} value={item.description} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default DishSummary;
